import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import { useIntl } from "react-intl";

import { InputField } from "../../../../components/input-field/InputField";
import { InputSelect } from "../../../../components/input-select/InputSelect";
import { CountryService } from "../../../../services/CountryService";
import CityService from "../../../../services/CityService";

interface BranchProps {
  name: string;
  company: string;
  logo: string;
  address: string;
  latitude: string;
  longitude: string;
  countryId: number;
  cityId: number;
}

const useStyles = makeStyles((theme) => ({
  main: {
    width: "100%",
    height: "100%",
    padding: 20,
    flexGrow: 1,
  },
  businessLogo: {
    width: 40,
    height: 40,
    marginRight: 10,
  },
  branchName: {
    fontSize: 32,
    fontWeight: 400,
  },
  tab: {
    textTransform: "none",
  },
  divider: {
    width: "100%",
    height: 2,
    backgroundColor: theme.palette.grey[300],
  },
}));

export const Branch = (props: BranchProps) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const {
    name,
    company,
    logo,
    address,
    latitude,
    longitude,
    countryId,
    cityId,
  } = props;
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);

  const loadCountries = async () => {
    setCountries([]);
    try {
      const countries = await CountryService.supportedCountries();
      if (countries.isSuccess && countries.data.code === 100) {
        const responseData = JSON.parse(JSON.stringify(countries.data.data));
        setCountries(responseData);
      }
    } catch (_) {}
  };

  const loadCities = async () => {
    setCities([]);
    const cities = await CityService.supportedCities(countryId);
    if (cities.isSuccess && cities.data.code === 100) {
      const responseData = JSON.parse(JSON.stringify(cities.data.data));
      setCities(responseData);
    }
  };

  useEffect(() => {
    loadCountries();
    loadCities();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Paper className={classes.main}>
      <Grid container spacing={2}>
        <Grid item container xs={12} sm={12} lg={12} direction="row">
          <img className={classes.businessLogo} src={logo} alt="Company Logo" />
          <Typography
            className={classes.branchName}
            variant="h4"
            component="h4"
          >
            {company}, {name}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} lg={12}>
          <InputSelect
            value={countryId}
            label={formatMessage({ id: "sharedScreen.country" })}
            fullWidth
            readOnly
          >
            {countries.map((country) => (
              <MenuItem value={country.id}>{country.designation}</MenuItem>
            ))}
          </InputSelect>
        </Grid>
        <Grid item xs={12} sm={12} lg={12}>
          <InputSelect
            value={cityId}
            label={formatMessage({ id: "sharedScreen.city" })}
            fullWidth
            readOnly
          >
            {cities.map((city) => (
              <MenuItem value={city.id}>{city.designation}</MenuItem>
            ))}
          </InputSelect>
        </Grid>
        <Grid item xs={12} sm={12} lg={12}>
          <InputField
            value={address}
            label={formatMessage({ id: "sharedScreen.address" })}
            fullWidth
            readOnly
            endAdornment={
              <InputAdornment position="end">
                <IconButton edge="end">
                  <LocationOnIcon />
                </IconButton>
              </InputAdornment>
            }
          />
        </Grid>
        <Grid item xs={12} sm={12} lg={12}>
          <InputField
            value={latitude}
            label={formatMessage({ id: "sharedScreen.latitude" })}
            fullWidth
            readOnly
            endAdornment={
              <InputAdornment position="end">
                <IconButton edge="end">
                  <LocationOnIcon />
                </IconButton>
              </InputAdornment>
            }
          />
        </Grid>
        <Grid item xs={12} sm={12} lg={12}>
          <InputField
            value={longitude}
            label={formatMessage({ id: "sharedScreen.longitude" })}
            fullWidth
            readOnly
            endAdornment={
              <InputAdornment position="end">
                <IconButton edge="end">
                  <LocationOnIcon />
                </IconButton>
              </InputAdornment>
            }
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
